export enum ErrorCode {
  Undefined = -1,
  NoResultsFound = 1,
}

